import { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import "../styles/assetDetails.css";

import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]);

const percentFormatter = (value) =>
  value != null ? `${(value * 100).toFixed(2)} %` : "";

const dateFormatter = (value) =>
  value ? new Date(value).toLocaleDateString("en-US") : "";


const getAlignmentStyle = (params) => {
  const value = params?.value;

  // actual numbers
  if (typeof value === "number") {
    return { textAlign: "right" };
  }

  // numeric strings like:
  // "25%", "-10.5", "1,245.88", etc.
  if (typeof value === "string") {
    const numericValue = Number(
      value
        .replace("%", "")
        .replace(/,/g, "")
        .trim()
    );

    const isValidNumber = !isNaN(numericValue);

    if (isValidNumber) {
      return { textAlign: "right" };
    }

    return { textAlign: "left" };
  }

  return null;
};

const PerformanceSummaryGrid = ({ data }) => {

  const boldIfNeeded = (params) => {
    if (params.data?.isPortfolioLevel) {
      return {
        fontWeight: "bold",
        backgroundColor: "#E6E3F0"
      };
    }

    if (params.data?.isWeightedIndex) {
      return {
        fontWeight: "bold"
      };
    }

    return null;
  };

  const columnDefs = useMemo(() => [
    {
      headerName: "",
      field: "strategyName",
      minWidth: 250,
      width: 280,
      cellRenderer: (params) => {
        const color = params.data?.colorCode;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {color && (
              <div
                style={{
                  width: 14,
                  height: 14,
                  backgroundColor: color
                }}
              />
            )}
            <span>{params.value}</span>
          </div>
        );
      },
      cellStyle: (params)=> {
        const boldStyle = boldIfNeeded(params)
        const alignmentStyle = getAlignmentStyle(params)
        return {...boldStyle, ...alignmentStyle}
      }
    },
    {
      headerName: "Month To Date",
      field: "mtd",
      headerClass: "ag-right-header",
      valueFormatter: (p) => percentFormatter(p.value),
      cellStyle: (params)=> {
        const boldStyle = boldIfNeeded(params)
        const alignmentStyle = getAlignmentStyle(params)
        return {...boldStyle, ...alignmentStyle}
      }
    },
    {
      headerName: "Year To Date",
      field: "ytd",
      headerClass: "ag-right-header",
      valueFormatter: (p) => percentFormatter(p.value),
      cellStyle: (params)=> {
        const boldStyle = boldIfNeeded(params)
        const alignmentStyle = getAlignmentStyle(params)
        return {...boldStyle, ...alignmentStyle}
      }
    },
    {
      headerName: "3 Years Annualized",
      field: "cumulativeReturnLast36Month",
    headerClass: "ag-right-header",
      valueFormatter: (p) => percentFormatter(p.value),
      cellStyle: (params)=> {
        const boldStyle = boldIfNeeded(params)
        const alignmentStyle = getAlignmentStyle(params)
        return {...boldStyle, ...alignmentStyle}
      }
    },
    {
      headerName: "5 Years Annualized",
      field: "cumulativeReturnLast60Month",
     headerClass: "ag-right-header",
      valueFormatter: (p) => percentFormatter(p.value),
      cellStyle: (params)=> {
        const boldStyle = boldIfNeeded(params)
        const alignmentStyle = getAlignmentStyle(params)
        return {...boldStyle, ...alignmentStyle}
      }
    },
    {
      headerName: "Since Inception Annualized",
      field: "inceptionToDate",
      headerClass: "ag-right-header",
      valueFormatter: (p) => percentFormatter(p.value),
      cellStyle: (params)=> {
        const boldStyle = boldIfNeeded(params)
        const alignmentStyle = getAlignmentStyle(params)
        return {...boldStyle, ...alignmentStyle}
      }
    },
    {
      headerName: "Inception Date",
      field: "classInceptionDate",
      headerClass: "ag-right-header",
      valueFormatter: (p) => dateFormatter(p.value),
      cellStyle: (params)=> {
        const boldStyle = boldIfNeeded(params)
        return {...boldStyle, textAlign:'right'}
      }
    }
  ], []);

  if (!data || data.length === 0) {
    return <div>No Data</div>;
  }

  return (
    <div className="ag-theme-alpine" style={{ width: "100%" }}>
      <AgGridReact
        theme={"legacy"}
        rowData={data}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        getRowStyle={(params) => {
            if (params.data?.isTotalPortfolio) {
              return {
                backgroundColor: "#E6E3F0",
                fontWeight: "bold"
              };
            }

            return {
              backgroundColor: "#FFFFFF"
            };
          }}
        defaultColDef={{
          flex:1,
          resizable: true,
          wrapHeaderText: true,
          autoHeaderHeight: true,
          minWidth:100,
          suppressHeaderMenuButton: true,
  suppressHeaderContextMenu: true
        }}
      />
    </div>
  );
};

export default PerformanceSummaryGrid;